import axios from "axios";

class request {
    
    //修改用户密码
    static modifyUserPassword(new_password,call_back,call_err) {
        axios({
            url: "flash_warehouse/user/modify_password",
            method: "PUT",
            data: {
                be_modified_user_id: parseInt(sessionStorage.getItem("user_id")),
                new_password: new_password
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //读取单据配置信息
    static ReadBillOfDocumentConfig() {
        axios({
            method: 'GET',
            url: 'flash_warehouse/config/read',
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            console.log(res)
            sessionStorage.setItem("config",JSON.stringify(res.data.data))
        }).catch((err)=>{
            console.log(err)
        })
    }

    //通过提供单据类型请求单据的数量
    static RequestBillOfDocumentAmountByType(type) {
        axios({
            method: "GET",
            url: "flash_warehouse/bill_of_document/info/by_type",
            params:{
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                type: type
            }
        }).then((res)=>{
            if(res.data.success) {
                sessionStorage.setItem(type + "总数", res.data.data)
                console.log(res.data.data)
            }
        }).catch((err)=>{
            console.log(err)
        })
    }

    //通过单据类型请求单据列表  仅限采购
    static RequestBillOfDocumentList(page_number,page_size,type,query_condition,call_back,call_err) {
        let params = {
            binding_user_id: parseInt(sessionStorage.getItem("user_id")),
            page_number: page_number,
            page_size: page_size,
            bill_of_document_id: '',
            create_datetime:'',
            department: '',
            transactor: '',
            bill_of_document_abstract: '',
            remark: '',
            unit: '',
            accrual: '',
            bill_of_document_type: type
        }
        if(query_condition){
            let shouldFillConditionToParams = (object,condition)=>{
                if(Object.hasOwn(object,condition) && (object[condition] !== undefined && object[condition] !== null)) return true
                else return false
            }
            if(shouldFillConditionToParams(query_condition,'inquiry_sheet_id')) params.inquiry_sheet_id = query_condition.inquiry_sheet_id
            if(shouldFillConditionToParams(query_condition,'create_datetime')) params.create_datetime = query_condition.create_datetime
            if(shouldFillConditionToParams(query_condition,'deoartment')) params.department = query_condition.department
            if(shouldFillConditionToParams(query_condition,'transactor')) params.transactor = query_condition.transactor
            if(shouldFillConditionToParams(query_condition,'bill_of_document_abstract')) params.bill_of_document_abstract = query_condition.bill_of_document_abstract
            if(shouldFillConditionToParams(query_condition,'remark')) params.remark = query_condition.remark
            if(shouldFillConditionToParams(query_condition,'unit')) params.unit = query_condition.unit
            if(shouldFillConditionToParams(query_condition,'accrual')) params.accrual = query_condition.accrual
        }
        axios({
            method: "GET",
            url: "flash_warehouse/purchase/bill_of_document/query",
            params: params
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //通过提供单据类型修改单据配置
    static RequestConfigModify (type,config,call_back,call_err) {
        axios({
            method: "PUT",
            url: 'flash_warehouse/config/modify',
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                bill_of_document_type: type,
                id_visible: config.value.idVisible,
                name_visible: config.value.nameVisible,
                weight_visible: config.value.weightVisible,
                height_visible: config.value.heightVisible,
                length_visible: config.value.lengthVisible,
                brand_visible: config.value.brandVisible,
                amount_visible: config.value.amountVisible,
                model_visible: config.value.modelVisible,
                place_of_production_visible: config.value.placeOfProductionVisible,
                price_visible: config.value.priceVisible,
                batch_number_visible: config.value.batchNumberVisible,
                quality_guarantee_period_visible: config.value.qualityGuaranteePeriodVisible,
                discount_visible: config.value.discountVisible,
                price_include_tax_visible: config.value.priceIncludeTaxVisible
            },
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //建立采购入库单
    static RequestCreatePurchaseInputWarehouse(head_data,goods_list,call_back,call_err) {
        axios({
            method: "POST",
            url: "flash_warehouse/purchase/input_warehouse_bill_of_document/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                input_warehouse_bill_of_document_id: head_data.id,
                transactor: head_data.transactor,
                warehouse_id: head_data.create_warehouse,
                unit: head_data.unit,
                department: head_data.department,
                bill_of_document_abstract: head_data.abstract?head_data.abstract:"",
                remarks: head_data.remark,
                goods_info_list: JSON.stringify(goods_list),
                
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //通过提供单据类型和单据编号删除指定的单据  仅采购
    static RequestDeletePurchaseBillOfDocument(bill_of_document_id,type,call_back,call_err) {
        axios({
            method: "DELETE",
            url: "flash_warehouse/purchase/bill_of_document/delete",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                bill_of_document_id: bill_of_document_id,
                type: type
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //创建采购订单
    static RequestCreateOrder(form_head,goods_list,call_back,call_err) {
        axios({
            method: "POST",
            url: "flash_warehouse/purchase/order/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                order_id: form_head.id,
                transactor: form_head.transactor,
                warehouse_id: form_head.create_warehouse,
                unit: form_head.unit,
                department: form_head.department,
                bill_of_document_abstract: form_head.abstract,
                remarks: form_head.remark,
                goods_info_list: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //创建采购退货单
    static RequestRetuenBillOfDocumentCreate(form_head,goods_list,call_back,call_err) {
        axios({
            method: "POST",
            url: "flash_warehouse/purchase/return_bill_of_document/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                return_bill_of_document_id: form_head.id,
                transactor: form_head.transactor,
                warehouse_id: form_head.create_warehouse,
                unit: form_head.unit,
                department: form_head.department,
                bill_of_document_abstract: form_head.abstract,
                remarks: form_head.remark,
                goods_info_list: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    } 
    //创建采购换货单
    static RequestReplacementBillOfDocumentCreate(form_head,goods_list,call_back,call_err) {
        axios({
            method: "POST",
            url: "flash_warehouse/purchase/replacement_bill_of_document/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                replacement_bill_of_document_id: form_head.id,
                transactor: form_head.transactor,
                warehouse_id: form_head.create_warehouse,
                unit: form_head.unit,
                department: form_head.department,
                bill_of_document_abstract: form_head.abstract,
                remarks: form_head.remark,
                goods_info_list: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
                call_back(res)
        }).catch((err)=>{
                call_err(err)
        })
    }
    
    //获取用户信息
    static RequestGetUserInfo(user_id,call_back,call_err) {
        axios({
            method: "GET",
            url: "flash_warehouse/user/user_info",
            params:{
                user_id: user_id
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //创建销售报价单
    static RequestSellQuotedPriceBillOfDocument(form_head,goods_list,call_back,call_err) {
        axios({
            method: "POST",
            url: "flash_warehouse/sell/quoted_price/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                quoted_price_sheet_id: form_head.id,
                transactor: form_head.transactor,
                warehouse_id: form_head.create_warehouse,
                unit: form_head.unit,
                department: form_head.department,
                bill_of_document_abstract: form_head.abstract,
                remarks: form_head.remark,
                goods_info_list: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
                call_back(res)
        }).catch((err)=>{
                call_err(err)
        })
    }

    //创建销售出库单
    static RequestSellOutputWarehouseBillOfDocument(form_head,goods_list,call_back,call_err) {
        axios({
            method: "POST",
            url: "flash_warehouse/sell/output_warehouse_bill_of_document/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                output_warehouse_bill_of_document_id: form_head.id,
                transactor: form_head.transactor,
                unit: form_head.unit,
                warehouse_id: form_head.create_warehouse,
                department: form_head.department,
                bill_of_document_abstract: form_head.abstract,
                remarks: form_head.remark,
                goods_info_list: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
                call_back(res)
        }).catch((err)=>{
                call_err(err)
        })
    }

    //创建销售订单
    static RequestSellCreateOrder(form_head,goods_list,call_back,call_err){
        axios({
            method: "POST",
            url: "flash_warehouse/sell/order/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                order_id: form_head.id,
                transactor: form_head.transactor,
                unit: form_head.unit,
                warehouse_id: form_head.create_warehouse,
                department: form_head.department,
                bill_of_document_abstract: form_head.abstract,
                remarks: form_head.remark,
                goods_info_list: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
                call_back(res)
        }).catch((err)=>{
                call_err(err)
        })
    }

    //创建销售退货单
    static RequestSellReturnBillOfDocumentCreate(form_head,goods_list,call_back,call_err) {
        axios({
            method: "POST",
            url: "flash_warehouse/sell/return/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                return_bill_of_document_id: form_head.id,
                transactor: form_head.transactor,
                unit: form_head.unit,
                warehouse_id: form_head.create_warehouse,
                department: form_head.department,
                bill_of_document_abstract: form_head.abstract,
                remarks: form_head.remark,
                goods_info_list: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
                call_back(res)
        }).catch((err)=>{
                call_err(err)
        })
    }

    //创建销售换货单
    static RequestSellReplaceBillOfDocumentCreate(form_head,goods_list,call_back,call_err){
        axios({
            method: "POST",
            url: "flash_warehouse/sell/replace/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                replace_bill_of_document_id: form_head.id,
                transactor: form_head.transactor,
                unit: form_head.unit,
                warehouse_id: form_head.create_warehouse,
                department: form_head.department,
                bill_of_document_abstract: form_head.abstract,
                remarks: form_head.remark,
                goods_info_list: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
                call_back(res)
        }).catch((err)=>{
                call_err(err)
        })
    }

    //查询销售单据，通过所提供的类型
    static RequestSellBillOfDocumentQuery(page_number,page_size,type,query_condition,call_back,call_err){
        let params = {
            binding_user_id: parseInt(sessionStorage.getItem("user_id")),
            page_number: page_number,
            page_size: page_size,
            bill_of_document_id: '',
            create_datetime:'',
            department: '',
            transactor: '',
            bill_of_document_abstract: '',
            remark: '',
            unit: '',
            accrual: '',
            bill_of_document_type: type
        }
        if(query_condition){
            let shouldFillConditionToParams = (object,condition)=>{
                if(Object.hasOwn(object,condition) && (object[condition] !== undefined && object[condition] !== null)) return true
                else return false
            }
            if(shouldFillConditionToParams(query_condition,'inquiry_sheet_id')) params.inquiry_sheet_id = query_condition.inquiry_sheet_id
            if(shouldFillConditionToParams(query_condition,'create_datetime')) params.create_datetime = query_condition.create_datetime
            if(shouldFillConditionToParams(query_condition,'deoartment')) params.department = query_condition.department
            if(shouldFillConditionToParams(query_condition,'transactor')) params.transactor = query_condition.transactor
            if(shouldFillConditionToParams(query_condition,'bill_of_document_abstract')) params.bill_of_document_abstract = query_condition.bill_of_document_abstract
            if(shouldFillConditionToParams(query_condition,'remark')) params.remark = query_condition.remark
            if(shouldFillConditionToParams(query_condition,'unit')) params.unit = query_condition.unit
            if(shouldFillConditionToParams(query_condition,'accrual')) params.accrual = query_condition.accrual
        }
        axios({
            method: "GET",
            url: "flash_warehouse/sell/bill_of_document/query",
            params: params
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //根据类型删除销售订单
    static RequestSellBillOfDocumentDelete(bill_of_document_id,type,call_back,call_err){
        axios({
            method: "DELETE",
            url: "flash_warehouse/sell/bill_of_document/delete",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                bill_of_document_id: bill_of_document_id,
                type: type
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //创建员工信息
    static RequestAddStaff(staff_info,call_back,call_err){
        axios({
            method: "POST",
            url: "flash_warehouse/staff/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                staff_id: staff_info.id,
                staff_name: staff_info.name,
                staff_phone_number: staff_info.phone_number,
                brief_name: staff_info.brief_name,
                remark: staff_info.remark,
                login_password: staff_info.login_password,
                pin_yin_code: staff_info.pinyin_code,
                is_manager: staff_info.is_manager === "0"? false : true,
                is_login_user: staff_info.is_login_user=== "0"? false : true,
                status: staff_info.status=== "0"? "停用" : "正常",
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //查询员工信息
    static RequestStaffInfo(page_number,page_size,criteria,call_back,call_err) {
        let params = {
            page_number: page_number,
            page_size: page_size,
            binding_user_id: parseInt(sessionStorage.getItem("user_id")),
            staff_id: -1,
            staff_name: "",
            staff_phone_number: "",
            brief_name: "",
            login_password: "",
            pin_yin_code: "",
            status: ""
        }
        if(criteria !== null && criteria !== undefined) {
            if(criteria.staff_id !== null && criteria.staff_id !== undefined) params.staff_id = parseInt(criteria.staff_id)
            if(criteria.staff_name !== null && criteria.staff_name !== undefined) params.staff_name = criteria.staff_name
            if(criteria.staff_phone_number != null && criteria.staff_phone_number !== undefined) params.staff_phone_number = criteria.staff_phone_number
            if(criteria.brief_name !== null && criteria.brief_name !== undefined)  params.brief_name = criteria.brief_name
            if(criteria.login_password !== null && criteria.login_password !== undefined) params.login_password = criteria.login_password
            if(criteria.pin_yin_code != null && criteria.pin_yin_code !== undefined) params.pin_yin_code = criteria.pin_yin_code
            if(criteria.status !== null && criteria.status !== undefined) params.status = criteria.status
        }
        axios({
            method: "GET",
            url: "flash_warehouse/staff/query",
            params:params
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //删除员工信息
    static RequestDeleteStaffInfo(staff_id,call_back,call_err){
        axios({
            method: "DELETE",
            url: "flash_warehouse/staff/delete",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                staff_id: staff_id
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //修改员工信息
    static RequestModifiedStaffInfo(be_modified_staff_id,new_staff_info,call_back, call_err ){
        axios({
            method: "POST",
            url: "flash_warehouse/staff/modify",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                be_modified_staff_id: be_modified_staff_id,
                staff_id: new_staff_info.value.id,
                staff_name: new_staff_info.value.name,
                staff_phone_number: new_staff_info.value.phone_number,
                brief_name: new_staff_info.value.brief_name === null || new_staff_info.value.brief_name === undefined ? '' : new_staff_info.value.brief_name,
                remark: new_staff_info.value.remark === null || new_staff_info.value.remark === undefined? "" : new_staff_info.value.remark,
                login_password: new_staff_info.value.login_password === null || new_staff_info.value.login_password === undefined ? "" : new_staff_info.value.login_password,
                pin_yin_code: new_staff_info.value.pinyin_code === null || new_staff_info.value.pinyin_code === undefined ? "" : new_staff_info.value.pinyin_code,
                is_login_user: new_staff_info.value.is_login_user==="1"?true:false,
                is_manager: new_staff_info.value.is_manager==="1"?true:false,
                status: new_staff_info.value.status === "1"?"正常":"停用",
                kpi: new_staff_info.value.kpi,
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求创建仓库
    static RequestCreateWarehouse(submitInfo,call_back,call_err){
        let data = {
            binding_user_id: parseInt(sessionStorage.getItem("user_id")),
            warehouse_id: submitInfo.value.warehouseId,
            warehouse_type: submitInfo.value.warehouseType,
            warehouse_name: submitInfo.value.warehouseName,
            warehouse_brief_name: submitInfo.value.warehouseBriefName,
            warehouse_pin_yin_code: submitInfo.value.warehousePinYinCode,
            warehouse_manage_id: submitInfo.value.warehouseManagerId,
            warehouse_remark: submitInfo.value.warehouseRemark,
            warehouse_consignee_name: submitInfo.value.warehouseConsigneeName,
            warehouse_consignee_phone_number: submitInfo.value.warehouseConsigneePhoneNumber,
            warehouse_zip_code: submitInfo.value.warehouseZipCode,
            warehouse_province: submitInfo.value.warehouseProvince,
            warehouse_city: submitInfo.value.warehouseCity,
            warehouse_district: submitInfo.value.warehouseDistrict,
            warehouse_street_address: submitInfo.value.warehouseStreetAddress,
        }
        axios({
            method: "POST",
            url: "flash_warehouse/warehouse/create",
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求查询仓库信息
    static RequestQueryWarehouseInfo(page_number,page_size,criteria,call_back,call_err){
        let params = {
            binding_user_id: parseInt(sessionStorage.getItem("user_id")),
            page_number: page_number,
            page_size: page_size,
            warehouse_id: "",
            warehouse_type: "",
            warehouse_name: "",
            warehouse_brief_name: "",
            warehouse_pin_yin_code: "",
            warehouse_manage_id: "", 
            warehouse_remark: "",
            warehouse_consignee_name: "",
            warehouse_consignee_phone_number: "",
            warehouse_zip_code: "",
            warehouse_province: "",
            warehouse_city: "",
            warehouse_district: "",
            warehouse_street_address: ""
        }
        if(criteria !== null && criteria !== undefined) {
            if(criteria.warehouseId) params.warehouse_id = criteria.warehouseId;
            if(criteria.warehouseType) params.warehouse_type = criteria.warehouseType;
            if(criteria.warehouseName) params.warehouse_name = criteria.warehouseName;
            if(criteria.warehouseBriefName) params.warehouse_brief_name = criteria.warehouseBriefName;
            if(criteria.warehousePinYinCode) params.warehouse_pin_yin_code = criteria.warehousePinYinCode;
            if(criteria.warehouseManageId) params.warehouse_manage_id = criteria.warehouseManageId;
            if(criteria.warehouseRemark) params.warehouse_remark = criteria.warehouseRemark;
            if(criteria.warehouseConsigneeName) params.warehouse_consignee_name = criteria.warehouseConsigneeName;
            if(criteria.warehouseConsigneePhoneNumber) params.warehouse_consignee_phone_number = criteria.warehouseConsigneePhoneNumber;
            if(criteria.warehouseZipCode) params.warehouse_zip_code = criteria.warehouseZipCode;
            if(criteria.warehouseProvince) params.warehouse_province = criteria.warehouseProvince;
            if(criteria.warehouseCity) params.warehouse_city = criteria.warehouseCity;
            if(criteria.warehouseDistrict) params.warehouse_district = criteria.warehouseDistrict;
            if(criteria.warehouseStreetAddress) params.warehouse_street_address = criteria.warehouseStreetAddress;

        }
        axios({
            method: "GET",
            url: "flash_warehouse/warehouse/query",
            params: params
        })
        .then((res)=>{
            call_back(res)
        })
        .catch((err)=>{
            call_err(err)
        })
    }
    //请求删除仓库信息
    static RequestDeleteWarehouseInfo(warehouse_id,call_back,call_err){
        axios({
            method: "DELETE",
            url: "flash_warehouse/warehouse/delete",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                warehouse_id: warehouse_id
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //请求修改仓库信息
    static RequestModifiedWarehouseInfo(be_modified_id,modify_info,call_back, call_err){
        let data = {
            binding_user_id: parseInt(sessionStorage.getItem('user_id')),
            be_modified_warehouse_id: be_modified_id,
            warehouse_id: modify_info.value.warehouseId,
            warehouse_type: modify_info.value.warehouseType,
            warehouse_name: modify_info.value.warehouseName,
            warehouse_brief_name: modify_info.value.warehouseBriefName,
            warehouse_pin_yin_code: modify_info.value.warehousePinYinCode,
            warehouse_manage_id: modify_info.value.warehouseManager,
            warehouse_remark: modify_info.value.warehouseRemark,
            warehouse_consignee_name: modify_info.value.warehouseConsigneeName === undefined?"" : modify_info.value.warehouseConsigneeName,
            warehouse_consignee_phone_number: modify_info.value.warehouseConsigneePhoneNumber===undefined?"": modify_info.value.warehouseConsigneePhoneNumber,
            warehouse_zip_code: modify_info.value.warehouseZipCode===undefined?"": modify_info.value.warehouseZipCode,
            warehouse_province: modify_info.value.warehouseProvince,
            warehouse_city: modify_info.value.warehouseCity,
            warehouse_district: modify_info.value.warehouseDistrict,
            warehouse_street_address: modify_info.value.warehouseStreetAddress
        }
        console.log("MODIFY",data)
        axios({
            method: "PUT",
            url: "flash_warehouse/warehouse/modify",
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //请求读取待审核商品列表
    static RequestWaitingCheckGoodsInfoList(page_number,page_size,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/stock/waiting_check/query",
            params: {
                page_number: page_number,
                page_size: page_size,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求读取待审核商品数量
    static RequestWaitingCheckGoodsAmount(call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/stock/waiting_check/amount",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求采购统计中检测入库
    static RequestWaitingCheckGoodsStock(goods_info_list,call_back,call_err){
        axios({
            method: "POST",
            url: "flash_warehouse/goods/create/batch",
            data:{
                goods_list: JSON.stringify(goods_info_list),
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
        .then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求所有库存信息
    static RequestGoodsInfo(params,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/goods/query",
            params: params
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求将所有采购统计中的数据入库
    static RequestWaitingCheckGoodsStockAll(call_back,call_err) {
        axios({
            method: "POST",
            url: "flash_warehouse/stock/waiting_check/all/storage",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求将所有采购统计中的数据拒绝入库
    static RequestWaitingCheckGoodsRejectAll(call_back,call_err) {
        axios({
            method: "DELETE",
            url: "flash_warehouse/stock/waiting_check/all/reject",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //将所选择的商品拒绝入库
    static RequestWaitingCheckGoodsReject(goods_list,call_back,call_err){
        axios({
            method: "DELETE",
            url: "flash_warehouse/stock/waiting_check/reject",
            data: {
                goods_json_str: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //查询请求所选则商品数量
    static RequestGoodsInfoAmount(call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/goods/goods/amount",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //查询请求所选则商品数量通过条件
    static RequestGoodsInfoAmountByCriteria(criteria,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/goods/goods/amount",
            params: criteria
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //查询指定仓库中，请求所选则商品数量
    static RequestWarehouseGoodsInfoAmount(warehouse_id,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/goods/goods/amount",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                warehouse_id: warehouse_id
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求修改货物的信息
    static RequestModifyGoodsInfo(be_modified_id,new_goods_info,call_back,call_err) {
        axios({
            method: "PUT",
            url: "flash_warehouse/goods/modify",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                be_modify_goods_id: be_modified_id,
                price: new_goods_info.price,
                amount: new_goods_info.amount,
                total_value: new_goods_info.totalValue,
                goods_id: new_goods_info.goodsId,
                goods_name: new_goods_info.goodsName,
                name_of_invoice: new_goods_info.nameOfInvoice,
                remark: new_goods_info.remark,
                reference_cost: new_goods_info.referenceCost,
                purchasing_cycle: new_goods_info.purchasingCycle,
                storage_location: new_goods_info.storageLocation,
                pin_yin_code: new_goods_info.pinYinCode,
                place_of_production: new_goods_info.placeOfProduction,
                commodity_tax_rate: new_goods_info.commodityTaxRate,
                weight: new_goods_info.weight,
                goods_tags: new_goods_info.goodsTags,
                tax_code: new_goods_info.taxCode,
                length: new_goods_info.length,
                width: new_goods_info.width,
                height: new_goods_info.height,
                bar_code_strategy: new_goods_info.barCodeStrategy,
                quality_guarantee_period: new_goods_info.qualityGuaranteePeriod,
                brand: new_goods_info.brand,
                specification: new_goods_info.specification,
                model: new_goods_info.model,
                brief_name: new_goods_info.briefName,
                first_level_classification: new_goods_info.firstLevelClassification,
                second_level_classification: new_goods_info.secondLevelClassification,
                third_level_classification: new_goods_info.thirdLevelClassification,
                warehouse_id: new_goods_info.warehouseId,
                sale_return_point_ratio: new_goods_info.saleReturnPointRatio
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求删除商品信息
    static RequestDeleteGoodsInfo(goods_id,call_back,call_err){
        axios({
            method: "DELETE",
            url: "flash_warehouse/goods/delete",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                goods_id: goods_id
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //请求打印模版列表
    static RequestPrintTemplateList(call_back, call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/config/print/read",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //上传打印模版
    static UploadPrintTemplate(templateJSON,print_content,call_back, call_err){
        axios({
            method: "POST",
            url: "flash_warehouse/config/print/create",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                print_template: templateJSON,
                print_content: print_content
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //删除打印模版
    static DeletePrintTemplate(criteria,call_back,call_err){
        axios({
            method: "DELETE",
            url: "flash_warehouse/config/print/delete",
            data: {
                print_config_id: parseInt(criteria.id),
                print_content: criteria.printContent,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //BI获取总价值
    static BIgetTotalValue(call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/bi/total/value",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //BI获取一段时间内的总价值列表
    static BIgetTotalValueOnPassTime(begin_time,end_time,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/bi/total/value",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                begin_time: begin_time,
                end_time: end_time
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //BI获取出库数量
    static BIgetOutputAmount(call_back,call_err) {
        axios({
            method: "GET",
            url: "flash_warehouse/bi/output/amount",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //BI获取出入库双曲线
    static BIGetIoDoubleLine(begin_time,end_time,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/bi/io/price/line",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                begin_time: begin_time,
                end_time: end_time
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //BI获取出库数量
    static BIgetOutputAmountOnPassTime(begin_time,end_time,call_back,call_err) {
        axios({
            method: "GET",
            url: "flash_warehouse/bi/output/amount",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                begin_time: begin_time,
                end_time: end_time
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //BI获取入库数量
    static BIgetInputAmount(call_back,call_err) {
        axios({
            method: "GET",
            url: "flash_warehouse/bi/input/amount",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //BI获取入库数量 在过去的一段时间内
    static BIgetInputAmountOnPassTime(begin_time,end_time,call_back,call_err) {
        axios({
            method: "GET",
            url: "flash_warehouse/bi/input/amount",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                begin_time: begin_time,
                end_time: end_time
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //BI获取总成本
    static BIgetTotalCost(call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/bi/total/cost",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //创建盘点任务单
    static CreateWarehouseCheckTask(data,call_back,call_err) {
        axios({
            method: "POST",
            url: "flash_warehouse/check/create/task",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                id: data.id,
                name: data.name,
                creator: data.creator,
                description: data.description,
                warehouse_id: data.warehouse_id,
                warehouse_name: data.warehouse_name 
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    // 获取仓库盘点任务
    static RequestWarehouseCheckTaskQuery(page_number,page_size,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/check/query/task/list",
            params: {
                binding_user_id: sessionStorage.getItem("user_id"),
                page_number: page_number,
                page_size: page_size
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    // 获取仓库盘点任务详情
    static RequestWarehouseChekTaskItem(page_number,page_size,warehouse_check_task_id,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/check/query/task/list/item",
            params:{
                binding_user_id: sessionStorage.getItem("user_id"),
                page_number: page_number,
                page_size: page_size,
                warehouse_check_task_id: warehouse_check_task_id
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //修改盘点项目状态
    static RequestWarehouseCheckTaskStatusChange(warehouse_check_task_id,goods_id,status,discrepancy_quantity,call_back,call_err) {
        axios({
            method: "PUT",
            url: "flash_warehouse/check/task/modify",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                warehouse_check_task_id: warehouse_check_task_id,
                goods_id: goods_id,
                status: status,
                discrepancy_quantity: discrepancy_quantity
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    static DelectWarehouseCheckTask(warehouse_check_task_id,call_back,call_err){
        axios({
            method: "DELETE",
            url: "flash_warehouse/check/task/delete",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                warehouse_check_task_id: warehouse_check_task_id
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    //获取盘点任务表项目总个数
    static GetWarehouseCheckTaskItemsAmount(task_id,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/check/query/task/item/amount",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                warehouse_check_task_id: task_id
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    // 获取待盘点任务表项列表
    static GetWarehouseTaskItemNoCheck(task_id,call_back, call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/check/query/task/criteria",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                warehouse_status: "待盘",
                binding_warehouse_check_task_id: task_id
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //完成盘点任务确认
    static FinshedCheckTask(task_id,call_back,call_err){
        axios({
            method: "PUT",
            url:"flash_warehouse/check/task/finished",
            params: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                warehouse_check_task_id: task_id
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //搜索单据
    static SearchBill(page_number,page_size,type,criteria,call_back,call_err){
        let params = {
            binding_user_id: parseInt(sessionStorage.getItem("user_id")),
            type: type,
            page_number: page_number,
            page_size: page_size,
            warehouse_id: criteria.warehouseId,
            bill_of_document_id: criteria.billOfDocumentId,
            status: criteria.status,
            transactor: criteria.transactor,
            begin_time: criteria.begin_time,
            end_time: criteria.end_time
        }
        axios({
            url: "flash_warehouse/bill_of_document/search",
            method: "GET",
            params: params
        })
        .then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //获取盘点列表中的列表数量
    static getWarehouseCheckTaskAmount(call_back,call_err) {
        axios({
            url: "flash_warehouse/check/amount",
            method: "GET",
            params:{
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //搜查过滤盘点列表
    static SearchWarehouseCheckTask(params,call_back,call_err) {
        axios({
            url: "flash_warehouse/check/search",
            method: "GET",
            params:params
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //获取供应商/客户列表
    static SearchCooperativePartnerList(params,call_back,call_err) {
        axios({
            url: "flash_warehouse/cooperative_partner/search",
            method: "GET",
            params: params
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //添加供应商或客户
    static AddCooperativePartner(formData,call_back,call_err){
        axios({
            url: "flash_warehouse/cooperative_partner/add",
            method: "POST",
            data: {
                name: formData.value.name,
                type: formData.value.type,
                advance_credit: formData.value.advance_credit,
                account_bank_name: formData.value.account_bank_name,
                bank_account: formData.value.bank_account,
                identification_number_of_the_taxpayer: formData.value.identification_number_of_the_taxpayer,
                address: formData.value.address,
                phone_number: formData.value.phone_number,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //修改供应商或客户
    static ModifyCooperativePartner(formData,call_back,call_err){
        axios({
            url: "flash_warehouse/cooperative_partner/modify",
            method: "PUT",
            data:{
                id: formData.value.id,
                name: formData.value.name,
                type: formData.value.type,
                advance_credit: formData.value.advance_credit,
                account_bank_name: formData.value.account_bank_name,
                bank_account: formData.value.bank_account,
                identification_number_of_the_taxpayer: formData.value.identification_number_of_the_taxpayer,
                address: formData.value.address,
                phone_number: formData.value.phone_number,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //删除供应商或客户
    static DeleteCooperativePartner(id,call_back,call_err) {
        axios({
            url: "flash_warehouse/cooperative_partner/delete",
            method: "DELETE",
            params: {
                id: id,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //MVP版本支付接口
    static PayCooperativePartnerMVP(id,pay_value,call_back,call_err){
        axios({
            url: "flash_warehouse/cooperative_partner/pay",
            method: "PUT",
            params: {
                id: id,
                pay_value: pay_value,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //MVP版本添账接口
    static DisPayCooperativePartnerMVP(id,pay_value,call_back,call_err){
        axios({
            url: "flash_warehouse/cooperative_partner/dis_pay",
            method: "PUT",
            params: {
                id: id,
                pay_value: pay_value,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //创建其他入库单
    static CreateOtherInputBillOfDocument(head_data,goods_list,call_back,call_err){
        axios({
            method: "POST",
            url: "flash_warehouse/bill_of_document/create/other_input",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                input_warehouse_bill_of_document_id: head_data.id,
                transactor: head_data.transactor,
                warehouse_id: head_data.create_warehouse,
                unit: head_data.unit,
                department: head_data.department,
                bill_of_document_abstract: head_data.bill_of_document_abstract?head_data.bill_of_document_abstract:"",
                remarks: head_data.remark,
                goods_info_list: JSON.stringify(goods_list),
                
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //创建其他出库单
    static CreateOtherOutputBillOfDocument(form_head,goods_list,call_back,call_err){
        axios({
            method: "POST",
            url: "flash_warehouse/bill_of_document/create/other_output",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                output_warehouse_bill_of_document_id: form_head.id,
                transactor: form_head.transactor,
                unit: form_head.unit,
                warehouse_id: form_head.create_warehouse,
                department: form_head.department,
                bill_of_document_abstract: form_head.abstract,
                remarks: form_head.remark,
                goods_info_list: JSON.stringify(goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
                call_back(res)
        }).catch((err)=>{
                call_err(err)
        })
    }
    //查询订单单据列表
    static RequestBillOfDocumentListPlus(page_number,page_size,type,query_condition,call_back,call_err){
        let params = {
            binding_user_id: parseInt(sessionStorage.getItem("user_id")),
            page_number: page_number,
            page_size: page_size,
            bill_of_document_id: '',
            create_datetime:'',
            department: '',
            transactor: '',
            bill_of_document_abstract: '',
            remark: '',
            unit: '',
            accrual: '',
            bill_of_document_type: type
        }
        if(query_condition){
            let shouldFillConditionToParams = (object,condition)=>{
                if(Object.hasOwn(object,condition) && (object[condition] !== undefined && object[condition] !== null)) return true
                else return false
            }
            if(shouldFillConditionToParams(query_condition,'inquiry_sheet_id')) params.inquiry_sheet_id = query_condition.inquiry_sheet_id
            if(shouldFillConditionToParams(query_condition,'create_datetime')) params.create_datetime = query_condition.create_datetime
            if(shouldFillConditionToParams(query_condition,'deoartment')) params.department = query_condition.department
            if(shouldFillConditionToParams(query_condition,'transactor')) params.transactor = query_condition.transactor
            if(shouldFillConditionToParams(query_condition,'bill_of_document_abstract')) params.bill_of_document_abstract = query_condition.bill_of_document_abstract
            if(shouldFillConditionToParams(query_condition,'remark')) params.remark = query_condition.remark
            if(shouldFillConditionToParams(query_condition,'unit')) params.unit = query_condition.unit
            if(shouldFillConditionToParams(query_condition,'accrual')) params.accrual = query_condition.accrual
        }
        axios({
            method: "GET",
            url: "flash_warehouse/bill_of_document/bill_of_document/query",
            params: params
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    //通过提供单据类型和单据编号删除指定的单据
    static RequestDeleteBillOfDocument(bill_of_document_id,type,call_back,call_err) {
        axios({
            method: "DELETE",
            url: "flash_warehouse/bill_of_document/bill_of_document/delete",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                bill_of_document_id: bill_of_document_id,
                type: type
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    static RequestShouldPay(binding_user_id,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/bi/should/pay",
            params: {
                binding_user_id: binding_user_id
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    static RequestShouldReceive(binding_user_id,call_back,call_err){
        axios({
            method: "GET",
            url: "flash_warehouse/bi/should/receive",
            params: {
                binding_user_id: binding_user_id
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    /**
     * 向AI请求数据
     * @param {*} message 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static RequestSendAiChat(message,call_back,call_err){
        axios({
            url: "flash_warehouse/ai/qwen_plus",
            method: "GET",
            params: {
                message: message,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }
    /**
     * 向AI请求数据 (流式回答)
     * @param {*} message 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static RequestSendAiChatStream(message,call_back,call_err){
        axios({
            url: "flash_warehouse/ai/qwen_plus/stream",
            method: "GET",
            params: {
                message: message,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    /**
     * 向AI请求数据，但要求AI结合业务数据
     * @param {*} message 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static RequestSendAiChatTag(message,call_back,call_err){
        axios({
            url: "flash_warehouse/ai/qwen_plus/tag",
            method: "GET",
            params: {
                message: message,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    /**
     * 向AI请求数据，但要求AI结合业务数据 (流式回答)
     * @param {*} message 
     * @param {*} call_back 
     * @param {*} call_err 
     */
        static RequestSendAiChatTagStream(message,call_back,call_err){
            axios({
                url: "flash_warehouse/ai/qwen_plus/tag/stream",
                method: "GET",
                params: {
                    message: message,
                    binding_user_id: parseInt(sessionStorage.getItem("user_id"))
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then((res)=>{
                call_back(res)
            }).catch((err)=>{
                call_err(err)
            })
        }
    /**
     * 审批单据
     * @param {*} bill_of_document_id 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static AudingBillOfDocument(bill_of_document_id,call_back,call_err){
        axios({
            url: "flash_warehouse/bill_of_document/bill_of_document/auditing",
            method: "POST",
            data: {
                bill_of_document_id: bill_of_document_id,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    /**
     * 驳回单据
     * @param {*} bill_of_document_id 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static RejectBillOfDocument(bill_of_document_id,call_back,call_err) {
        axios({
            url:"flash_warehouse/bill_of_document/bill_of_document/reject",
            method: "POST",
            data: {
                bill_of_document_id: bill_of_document_id,
                binding_user_id: parseInt(sessionStorage.getItem("user_id"))
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then((res)=>{
            call_back(res)
        }).catch((err)=>{
            call_err(err)
        })
    }

    /**
     * 通过询价单创建采购订单
     * @param {*} bill_of_document 
     * @param {*} bill_of_document_goods_list 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static CreatePurchaseOrderByInquiry(bill_of_document,bill_of_document_goods_list ,call_back,call_err){
        axios({
            url:"flash_warehouse/bill_of_document_create_by_other/create_purchase_order_by_inquiry",
            method: "POST",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                bill_of_document_id: bill_of_document.bill_of_document_id,
                transactor: bill_of_document.transactor,
                warehouse_id: bill_of_document.warehouse_id,
                unit: bill_of_document.unit,
                department: bill_of_document.department,
                bill_of_document_abstract: bill_of_document.bill_of_document_abstract,
                bill_of_document_goods_list_json: JSON.stringify(bill_of_document_goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res=>{
            call_back(res)
        }).catch(err=>{
            call_err(err)
        })
    }

    /**
     * 通过采购订单生成采购入库单
     * @param {*} bill_of_document 
     * @param {*} bill_of_document_goods_list 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static CreatePurchaseInputWarehouseByOrder(bill_of_document,bill_of_document_goods_list ,call_back,call_err){
        axios({
            url:"flash_warehouse/bill_of_document_create_by_other/create_purchase_input_warehouse_by_order",
            method: "POST",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                bill_of_document_id: bill_of_document.bill_of_document_id,
                transactor: bill_of_document.transactor,
                warehouse_id: bill_of_document.warehouse_id,
                unit: bill_of_document.unit,
                department: bill_of_document.department,
                bill_of_document_abstract: bill_of_document.bill_of_document_abstract,
                bill_of_document_goods_list_json: JSON.stringify(bill_of_document_goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res=>{
            call_back(res)
        }).catch(err=>{
            call_err(err)
        })
    }

    /**
     * 通过采购订单生成采购退货单
     * @param {*} bill_of_document 
     * @param {*} bill_of_document_goods_list 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static CreatePurchaseReturnByOrder(bill_of_document,bill_of_document_goods_list ,call_back,call_err){
        axios({
            url:"flash_warehouse/bill_of_document_create_by_other/create_purchase_return_by_order",
            method: "POST",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                bill_of_document_id: bill_of_document.bill_of_document_id,
                transactor: bill_of_document.transactor,
                warehouse_id: bill_of_document.warehouse_id,
                unit: bill_of_document.unit,
                department: bill_of_document.department,
                bill_of_document_abstract: bill_of_document.bill_of_document_abstract,
                bill_of_document_goods_list_json: JSON.stringify(bill_of_document_goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res=>{
            call_back(res)
        }).catch(err=>{
            call_err(err)
        })
    }

    /**
     * 通过销售报价单生成销售订单
     * @param {*} bill_of_document 
     * @param {*} bill_of_document_goods_list 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static CreateSellOrderByQuoted(bill_of_document,bill_of_document_goods_list ,call_back,call_err){
        axios({
            url:"flash_warehouse/bill_of_document_create_by_other/create_sell_order_by_quoted",
            method: "POST",
            data: {
                binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                bill_of_document_id: bill_of_document.bill_of_document_id,
                transactor: bill_of_document.transactor,
                warehouse_id: bill_of_document.warehouse_id,
                unit: bill_of_document.unit,
                department: bill_of_document.department,
                bill_of_document_abstract: bill_of_document.bill_of_document_abstract,
                bill_of_document_goods_list_json: JSON.stringify(bill_of_document_goods_list)
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res=>{
            call_back(res)
        }).catch(err=>{
            call_err(err)
        })
    }

        /**
     * 通过销售出库单生成销售订单
     * @param {*} bill_of_document 
     * @param {*} bill_of_document_goods_list 
     * @param {*} call_back 
     * @param {*} call_err 
     */
    static CreateSellOutputByOrder(bill_of_document,bill_of_document_goods_list ,call_back,call_err){
            axios({
                url:"flash_warehouse/bill_of_document_create_by_other/create_sell_output_by_order",
                method: "POST",
                data: {
                    binding_user_id: parseInt(sessionStorage.getItem("user_id")),
                    bill_of_document_id: bill_of_document.bill_of_document_id,
                    transactor: bill_of_document.transactor,
                    warehouse_id: bill_of_document.warehouse_id,
                    unit: bill_of_document.unit,
                    department: bill_of_document.department,
                    bill_of_document_abstract: bill_of_document.bill_of_document_abstract,
                    bill_of_document_goods_list_json: JSON.stringify(bill_of_document_goods_list)
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res=>{
                call_back(res)
            }).catch(err=>{
                call_err(err)
            })
    }
}
export default request;